import { Table, Tag, Tooltip } from 'antd';
import { useFormatMessage } from 'hooks';
import moment from 'moment';
import paths from 'pages/Router/paths';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { ClipLoader } from 'react-spinners';
import { fetchUsers, unlockUser } from 'state/actions/users';
import { fetchRoles } from 'state/actions/roles';
import { regexInput } from 'utils/regex';
// import './User.css';
import './PanelUser.scss';
import { setBreadcrumb } from 'state/actions/breadcrumb';
import PageHeader from 'design-components/PageHeader';
import { log } from 'utils';
import { getRole } from 'utils/secrets';

function PanelUser() {
  const [search, setSearch] = useState('');

  const {
    usersList,
    // isAdmin,
    error,
    loading,
    deleted,
    userData,
    roles,
    unlock,
  } = useSelector(
    (state) => ({
      usersList: state.users.list,
      // isAdmin: state.auth.userData.isAdmin,
      error: state.users.error,
      loading: state.users.loading,
      deleted: state.users.deleted,
      userData: state.auth.userData,
      roles: state.roles.list,
      unlock: state.users.unlock,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  const [role, setRole] = useState(null);

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const fetchData = async () => {
    try {
      const roleData = await getRole();
      setRole(roleData);
    } catch (error) {
      log('Error retrieving role:', error);
    }
  };

  useEffect(() => {
    dispatch(
      setBreadcrumb([
        { menu: 'Admin Panel', link: '/paneluser' },
        { menu: 'User Authentication Policy', link: '/paneluser' },
      ])
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (role === 'admin' || role === 'superadmin') {
      dispatch(fetchUsers());
      dispatch(fetchRoles());
    }
  }, [dispatch, role]);

  useEffect(() => {
    if (deleted && !loading) {
      dispatch(fetchUsers());
    }
  }, [deleted, loading]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (unlock) {
      dispatch(fetchUsers());
    }
  }, [unlock]); // eslint-disable-line react-hooks/exhaustive-deps

  const [searchError, setSearchError] = useState(null);

  const handleSearch = (e) => {
    setSearchError(null);
    if (!regexInput(e.target.value) && e.target.value) {
      setSearchError('Search cannot using special character');
    }
    setSearch(e.target.value);
  };

  const onUnlockUser = (id) => {
    dispatch(unlockUser(id));
  };

  const redirect =
    role === 'admin' || role === 'superadmin' ? (
      false
    ) : (
      <Redirect to={paths.ROOT} />
    );

  const columns = [
    {
      title: useFormatMessage('Users.name'),
      dataIndex: 'name',
      render: (text) => <div className="table-name">{text}</div>,
    },
    {
      title: useFormatMessage('Users.email'),
      dataIndex: 'email',
    },
    {
      title: useFormatMessage('Users.role'),
      dataIndex: 'roleAccess',

      render: (text, record) => {
        const roleUser = roles.find((r) => r._id === record.roleId);
        if (record.roleId && roleUser) {
          return <div>{roleUser.name}</div>;
        }
        return <span>-</span>;
      },
    },
    {
      title: 'User Status',
      dataIndex: 'status',

      render: (text, record) => {
        if (record.isLockedOut) {
          return (
            <div className="status">
              <Tag color="red">Locked Out</Tag>
              <div>
                <Tooltip title="Unlock user">
                  <div
                    onClick={() => onUnlockUser(record.email)}
                    className="btn btn--edit"
                  >
                    <i className="feather-unlock" />
                    Unlock
                  </div>
                </Tooltip>
              </div>
            </div>
          );
        }
        return <Tag color="green">Active</Tag>;
      },
    },
    {
      title: 'Password Expired Date',
      dateIndex: 'lastPasswordChangedDate',

      render: (text, record) => {
        const roleUser = roles.find((r) => r._id === record.roleId);
        if (record.lastLoginDate && roleUser) {
          return (
            <Tag className="table-date">
              <div>{`${moment(record.lastPasswordChangeDate)
                .utcOffset('+08:00')
                .add(roleUser.expirationDuration, 'days')
                .format('h:mm A, MMM Do, YYYY')}`}</div>
            </Tag>
          );
        }
        return <span>-</span>;
      },
    },
  ];

  const data = search
    ? usersList.filter((el) => {
        const clonedElem = { ...el };
        delete clonedElem.id;
        const name =
          clonedElem.name &&
          clonedElem.name.toLowerCase().includes(search.toLowerCase());
        const org =
          clonedElem.organizationName &&
          clonedElem.organizationName
            .toLowerCase()
            .includes(search.toLowerCase());
        const email =
          clonedElem.email &&
          clonedElem.email.toLowerCase().includes(search.toLowerCase());
        const role =
          clonedElem.role &&
          clonedElem.role.toLowerCase().includes(search.toLowerCase());
        if (name || org || email || role) {
          return clonedElem;
        }
        return false;
      })
    : // eslint-disable-next-line
      usersList.filter((el) => {
        if (role && role === 'superadmin') {
          return el.role !== 'superadmin';
        } else if (role === 'admin') {
          return (
            el.role !== 'superadmin' &&
            el.organizationName === userData.organizationName
          );
        }
      });

  return (
    <section className="panel-user">
      {role && redirect}
      <PageHeader
        title="Users"
        isGrid={false}
        isSearch={true}
        searchValue={search}
        searchAction={handleSearch}
        searchPlaceholder="Enter User's Name"
        searchError={searchError}
        isAdd={false}
        addLabel=""
      />

      <div className="panel-user__table">
        {loading ? (
          <ClipLoader />
        ) : (
          <Table columns={columns} dataSource={data} rowKey="id" />
        )}
        {error && 'Show error'}
      </div>
    </section>
  );
}

export default PanelUser;
